import { makeQuery } from 'shared/utilities';

type RequestType = {
    id: string,
    changeKey: string
};

type ResponseType = {};

export const calendarItemsDeleteQuery = async function (data: RequestType) {
    return await makeQuery<ResponseType>('/calendar-items/delete', { json: data });
}
